import moment = require("moment");
import * as React from "react";
import DatePicker from "react-datepicker";
import {Button, DateRangePicker, icons} from "@vebox/etui-core";
import {Buttons} from "../../../components/buttons/Buttons";
import {I18n} from "../../../components/Utils/i18n";
import {AlarmsGlobalMonitorTexts} from "../../../components/Utils/translations/AppTranslations";
import {AlarmSeverity, AlarmSeverityCount} from "../data/AlarmsMonitorData";
import {AlarmsMonitorDataMapper} from "../utils/AlarmsMonitorDataMapper";
import {ChipButton} from "../../../components/buttons/ChipButton";
import {getChipColor} from "../../../equipment/details/alarms/subfilters/Commons";
import {height} from "@vebox/etui-system";

declare var LOCALE: string;

interface GlobalMonitorHeaderProps {
    texts: AlarmsGlobalMonitorTexts;
    selectedSeverity: AlarmSeverity;
    severities: AlarmSeverityCount[];
    onExportClick: () => void;
    onGlobalFiltersClick: () => void;
    globalFiltersOpened: boolean;
    onFiltersApply: (fromDate: Date, toDate: Date, severityGuid: string[]) => void;
    filtersFromDate: Date;
    filtersToDate: Date;
    filtersSeveritiesGuid: string[];
}

interface GlobalMonitorHeaderState {
    filtersFromDate: Date;
    filtersToDate: Date;
    filtersSeveritiesGuid: string[];
    startDate: Date;
    endDate: Date;
}

/*
*
* THIS CLASS IS NOT USED ANYMORE,ALL OF ITS METHODS AND COMPONENTS HAVE BEEN
* MOVED TO GlobalMonitorPage.tsx
*
* */

export class GlobalMonitorHeader extends React.Component<GlobalMonitorHeaderProps, GlobalMonitorHeaderState> {
    constructor(props) {
        super(props);
        this.onFiltersApply = this.onFiltersApply.bind(this);
        this.onFiltersClose = this.onFiltersClose.bind(this);
        this.areFiltersEmpty = this.areFiltersEmpty.bind(this);
        this.onFiltersReset = this.onFiltersReset.bind(this);
        this.toggleSeverity = this.toggleSeverity.bind(this);
        this.changeFromDate = this.changeFromDate.bind(this);
        this.changeToDate = this.changeToDate.bind(this);
        this.state = {
            filtersFromDate: props.filtersFromDate != null ? new Date(props.filtersFromDate) : null,
            filtersToDate: props.filtersToDate != null ? new Date(props.filtersToDate) : null,
            filtersSeveritiesGuid: props.filtersSeveritiesGuid != null ? [...props.filtersSeveritiesGuid] : null,
            startDate: undefined,
            endDate: undefined,
        };
    }

    public render() {
        return (
            <div className={"monitor-header-container"}>
                {!this.props.globalFiltersOpened &&
                <div className={"monitor-header"}/>
                }
                {this.renderFilters()}
            </div>
        );
    }

    private onFiltersApply() {
        this.props.onFiltersApply(
            this.state.filtersFromDate != null ? new Date(this.state.filtersFromDate) : null,
            this.state.filtersToDate != null ? new Date(this.state.filtersToDate) : null,
            this.state.filtersSeveritiesGuid != null ? [...this.state.filtersSeveritiesGuid] : null,
        );
    }

    private onFiltersClose() {
        this.props.onGlobalFiltersClick();
    }

    private areFiltersEmpty() {
        return this.props.filtersToDate == null
            && this.props.filtersFromDate == null
            && (this.props.filtersSeveritiesGuid == null || this.props.filtersSeveritiesGuid.length === 0);
    }

    private onFiltersReset() {
        this.setState(
            {
                filtersToDate: null,
                filtersFromDate: null,
                filtersSeveritiesGuid: null,
                startDate: undefined,
                endDate: undefined,
            },
        );
        this.props.onFiltersApply(
            null,
            null,
            null,
        );
    }

    private renderFilters() {
        if (!this.props.globalFiltersOpened) {
            return null;
        }
        const severitiesInfo = this.props.severities.map(
            (severity) => {
                return severity.severityInfo;
            },
        );
        const severities = this.props.severities.map(
            (severity, index) => {
                const severityColor = AlarmsMonitorDataMapper.getSeverityColor(
                    severitiesInfo,
                    severity.severityInfo.guid,
                );
                return (
                    <ChipButton
                        label={severity.severityInfo.name}
                        key={severity.severityInfo.guid}
                        onChange={
                            // tslint:disable-next-line:jsx-no-lambda
                            () => this.toggleSeverity(severity.severityInfo.guid)
                        }
                        checked={this.isSeveritySelected(severity.severityInfo.guid)}
                        color={getChipColor(false, this.isSeveritySelected(severity.severityInfo.guid))}
                        accentColor={severityColor}
                    />
                );
            },
        );
        const texts = this.props.texts;
        return (
            <div className={"global-filters-container"}>
                <div className={"global-filters-header"}>
                    <div className={"global-filters-title"}/>
                    <div className={"close-global-filters-button"}>
                        <Button
                            iconProps={{glyph: icons.CLOSE}}
                            onClick={
                                this.onFiltersClose
                            }
                            shape="circle"
                            height={24}
                            width={24}
                        />
                    </div>
                </div>
                <div className={"global-filters-content"}>
                    <div className={"global-filters__filter alarm-severities-filter"}>
                        <p className={"filter-label"}>{texts.showAlarmsFiltered}</p>
                        <ul style={{marginLeft: "5px"}}>
                            {severities}
                        </ul>
                    </div>
                    <div className={"global-filters__filter alarm-date-filter"}>
                        <div className="date-picker-element">
                            <DateRangePicker
                                label={`${texts.from} - ${texts.to}`}
                                styles={{
                                    root: {
                                        height: "16px",
                                    }
                                }}
                                /*
                                * ↓ Il formato della data è settato in maniera sbagliata,
                                * è un fix provvisorio in attesa del fix del componente ETUI
                                * TODO [ETUI] implementare il dateformat quando il componente ETUI sarà stato cambiato
                                * */
                                dateFormat={I18n.getLocaleDateFormat(LOCALE) === "MM/dd/yyyy" ? "MM/DD/YYYY" : "DD/MM/YYYY"}
                                onChange={
                                    // tslint:disable-next-line:jsx-no-lambda
                                    (p) => {
                                        this.setState({
                                                filtersFromDate: p.startDate,
                                                filtersToDate: p.endDate,
                                            },
                                        );
                                    }}
                                startDate={this.state.filtersFromDate}
                                endDate={this.state.filtersToDate}
                            />
                        </div>
                    </div>
                </div>
                <div className={"global-filters-footer"}>
                    <Buttons.ButtonWithIcon
                        key={2}
                        code={"reset"}
                        icon={"./images/buttons/icon-cancelFilter.png"}
                        selected={false}
                        onClick={this.onFiltersReset}
                    />
                    <Buttons.ButtonWithIcon
                        key={1}
                        code={"save"}
                        icon={"./images/buttons/icon-apply.png"}
                        selected={false}
                        onClick={this.onFiltersApply}
                    />
                </div>
            </div>
        );
    }

    private isSeveritySelected(severityGuid: string) {
        return this.state.filtersSeveritiesGuid == null
            || this.state.filtersSeveritiesGuid.indexOf(severityGuid) === -1;
    }

    private toggleSeverity(severityGuid) {
        // tslint:disable-next-line:radix
        let filteredSeverities = this.state.filtersSeveritiesGuid;
        if (this.isSeveritySelected(severityGuid)) {
            if (filteredSeverities == null) {
                filteredSeverities = [];
            }
            filteredSeverities.push(severityGuid);
        } else {
            filteredSeverities[filteredSeverities.indexOf(severityGuid)] = null;
        }
        this.setState({
                filtersSeveritiesGuid: filteredSeverities.filter(
                    (element) => {
                        return element != null;
                    },
                ),
            },
        );
    }

    private changeFromDate(date) {
        let toDate = this.state.filtersToDate;
        if (toDate == null) {
            toDate = moment(new Date()).endOf("day").toDate();
        } else if (toDate < date) {
            toDate = moment(date).endOf("day").toDate();
        }
        this.setState({
                filtersFromDate: moment(date).startOf("day").toDate(),
                filtersToDate: toDate,
            },
        );
    }

    private changeToDate(date) {
        let fromDate = this.state.filtersFromDate;
        if (fromDate > date) {
            fromDate = moment(date).startOf("day").toDate();
        }
        this.setState({
                filtersFromDate: fromDate,
                filtersToDate: moment(date).endOf("day").toDate(),
            },
        );
    }
}
